import styled from "styled-components";
import { theme } from "../../../config";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.custom.background};
  padding: 57px 83px 15px 83px;
  @media ${theme.breakpoints.mobileAndTablet} {
    padding: 25px 0 15px 16px;
  }
  overflow: auto;
`;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin-bottom: 1em;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 22px;
    line-height: 26px;
  }
`;

export const TableWrapper = styled.div`
  .ant-picker-clear {
    display: none;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;

  & .ant-btn {
    width: 161px;
    padding: 0 20px 0 20px;
  }
`;

export const TableButtonWrapper = styled.div`
  & .ant-btn {
    width: 75px;
    height: 22px;
    padding: 0 20px 0 20px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const TextStyled = styled.div.attrs((props: { isClosed: boolean }) => ({
  ...props,
}))`
  color: ${props => {
    return props.isClosed ? "#8C8C8C" : "#111111";
  }};
`;
